export const getLessonByTeacherIdQuery = (id) => {
  const query = `
    {
        products(first: 9, query: "vendor:${id}") {
            edges {
                node {
                    id
                    title
                    description
                    vendor
                    productType
                    options { 
                        name
                        values
                    }
                    priceRange {
                        minVariantPrice {
                            currencyCode
                        }
                    }
                    variants(first: 3) {
                        edges {
                            node {
                                id
                                price {
                                  amount
                                  currencyCode
                                }
                                title
                                sku
                            }
                        }
                    }
                }
            }
        }
    }`;
  return query;
};
